import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import "../css/ContactMessages.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DashboardFooter from "./DashboardFooter";

const API_URL = "https://auxititpt.org/Backend/contact_api.php";

const ContactMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showReplyModal, setShowReplyModal] = useState(false);
  const [replyMessage, setReplyMessage] = useState("");
  const [selectedMsg, setSelectedMsg] = useState(null);

  // Fetch messages from backend
  const loadMessages = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setMessages(data);
    } catch (err) {
      console.error("Failed to load messages", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMessages();
  }, []);

  const handleReply = (msg) => {
    setSelectedMsg(msg);
    setShowReplyModal(true);
  };

 const handleDelete = async (id) => {
  if (!window.confirm("Delete this message?")) return;

  try {
    const res = await fetch(`${API_URL}?id=${id}`, {
      method: "DELETE",
    });

    const result = await res.json();

    if (result.status === "success") {
      setMessages(messages.filter((msg) => msg.id !== id));
    } else {
      alert("Failed to delete. Try again.");
    }
  } catch (error) {
    console.error("Delete error:", error);
  }
};

  const handleSendReply = () => {
    alert(`Reply Sent To: ${selectedMsg.email}\n\n${replyMessage}`);
    setReplyMessage("");
    setShowReplyModal(false);
  };

  return (
    <div className="d-flex dashboard-container">
      <Sidebar />

      <div className="main-content flex-grow-1">
        <Header />

        <div className="container-fluid p-4">
          <div className="card shadow p-4">
            <h4 className="mb-4 fw-bold text-primary">📩 Contact Messages</h4>

            {loading ? (
              <p>Loading messages...</p>
            ) : (
              <Table striped bordered hover responsive>
                <thead className="table-primary text-center align-middle">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Subject</th>
                    <th>Message</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {messages.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center text-muted">
                        No messages yet.
                      </td>
                    </tr>
                  ) : (
                    messages.map((msg, index) => (
                      <tr key={msg.id}>
                        <td>{index + 1}</td>
                        <td>{msg.name}</td>
                        <td>{msg.email}</td>
                        <td>{msg.subject}</td>
                        <td>{msg.message}</td>
                        <td>{msg.created_at}</td>
                        <td className="text-center">
                          {/* <Button
                            variant="success"
                            size="sm"
                            className="me-2"
                            onClick={() => handleReply(msg)}
                          >
                            Reply
                          </Button> */}

                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDelete(msg.id)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            )}
          </div>
        </div>

        <DashboardFooter />
      </div>

      {/* Reply Modal */}
      <Modal show={showReplyModal} onHide={() => setShowReplyModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Reply to {selectedMsg?.name}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control type="text" disabled value={selectedMsg?.email || ""} />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Your Reply</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={replyMessage}
                onChange={(e) => setReplyMessage(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReplyModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSendReply}>
            Send Reply
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ContactMessages;
